import { Box, Skeleton, Stack } from '@mui/material';

export default function LoadingInfo({ smUp }) {
  return (
    <Box
      sx={{
        display: 'grid',
        columnGap: 2,
        rowGap: 3,
        gridTemplateColumns: smUp ? 'repeat(2, 1fr)' : '1fr',
        m: 1,
        mb: 4,
      }}
    >
      <Stack>
        <Skeleton variant="text" sx={{ fontSize: 'overline' }} />
        <Skeleton variant="text" sx={{ fontSize: 'body1' }} />
      </Stack>
      <Stack>
        <Skeleton variant="text" sx={{ fontSize: 'overline' }} />
        <Skeleton variant="text" sx={{ fontSize: 'body1' }} />
      </Stack>
      <Stack>
        <Skeleton variant="text" sx={{ fontSize: 'overline' }} />
        <Skeleton variant="text" sx={{ fontSize: 'body1' }} />
      </Stack>
      <Stack>
        <Skeleton variant="text" sx={{ fontSize: 'overline' }} />
        <Skeleton variant="text" sx={{ fontSize: 'body1' }} />
      </Stack>
    </Box>
  );
}
